import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import ErlangSvgColor from '../assets/erlang.svg';

export const ErlangColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-erlang" className={cx('sdkIcon', className)} size={size} {...props}>
    <ErlangSvgColor />
  </LegacyIcon>
);
